const namespace = 'INVOICEITEMS';

export const REQUEST_INVOICEITEMS = `${namespace}/REQUEST_INVOICEITEMS`;
export const RECEIVE_INVOICEITEMS_SUCCESS = `${namespace}/RECEIVE_INVOICEITEMS_SUCCESS`;
export const RECEIVE_INVOICEITEMS_FAILURE = `${namespace}/RECEIVE_INVOICEITEMS_FAILURE`;
